import { IconButton, Stack, useTheme } from "@mui/material";
import { Ellipsis, MessageCircle } from "lucide-react";
import { type FC, useState } from "react";
import type { AgentDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { ContactDrawer } from "web_myplann/Shared/Components/ContactDrawer";
import { useOpenAgentChat } from "web_myplann/Shared/Hooks/useOpenAgentChat";
import { getAgentChatTitle } from "web_myplann/Shared/Utils/getAgentChatTitle";

type Props = {
	contact: AgentDetailResponseDTO | undefined;
};

export const ContactHeaderActions: FC<Props> = ({ contact }) => {
	const { palette, iconSize } = useTheme();
	const { t } = useResource();
	const openAgentChat = useOpenAgentChat();
	const [contactOpen, setContactOpen] = useState(false);

	return (
		<>
			<Stack direction="row" alignItems="center">
				<IconButton
					variant="ghost"
					aria-label={t(Resources.Common.writeToAdvisor)}
					onClick={() => {
						if (contact) {
							openAgentChat({
								uid: contact.uid,
								title: getAgentChatTitle(contact),
								conversationId: contact.conversationId,
							});
						}
					}}
				>
					<MessageCircle size={iconSize.md} color={palette.grey[700]} />
				</IconButton>
				<IconButton
					variant="ghost"
					aria-label={t(Resources.Common.moreOptions)}
					onClick={() => setContactOpen(true)}
				>
					<Ellipsis size={iconSize.md} color={palette.grey[700]} />
				</IconButton>
			</Stack>
			<ContactDrawer
				open={contactOpen}
				onClose={() => setContactOpen(false)}
				phone={contact?.phone ?? undefined}
				email={contact?.email}
			/>
		</>
	);
};
